<template>
  <div class="not-found-container">
    <div class="not-found-content">
      <!-- <h1>502</h1> -->
      <p>服务正在维护升级中,请稍后重试!</p>
      <button class="back-home" @click="goToHome">返回首页</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  methods: {
    goToHome() {
      if (this.$route.path !== '/') {
        this.$router.push('/');
      }
    }
  }
};
</script>

<style scoped>
.not-found-container {
    z-index: 9999;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
}
.not-found-content {
  text-align: center;
  background: #fff;
  padding: 48px 32px;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.08);
}
.not-found-content h1 {
  font-size: 72px;
  color: #26c6da;
  margin-bottom: 16px;
  font-weight: bold;
}
.not-found-content p {
  font-size: 20px;
  color: #666;
  margin-bottom: 32px;
}
.back-home {
  display: inline-block;
  padding: 10px 32px;
  background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
  color: #fff;
  border-radius: 24px;
  text-decoration: none;
  font-size: 18px;
  transition: background 0.2s;
}
.back-home:hover {
  background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
}
</style>